"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PmVoucherDepositResponseStatus = void 0;
var PmVoucherDepositResponseStatus;
(function (PmVoucherDepositResponseStatus) {
    PmVoucherDepositResponseStatus["OK"] = "OK";
    PmVoucherDepositResponseStatus["INVALID_VOUCHER_NUM"] = "INVALID_VOUCHER_NUM";
    PmVoucherDepositResponseStatus["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    PmVoucherDepositResponseStatus["PAYMENT_GATEWAY_INACTIVE"] = "PAYMENT_GATEWAY_INACTIVE";
    PmVoucherDepositResponseStatus["PLAYER_IS_BLOCKED"] = "PLAYER_IS_BLOCKED";
    PmVoucherDepositResponseStatus["PLAYER_NOT_FOUND"] = "PLAYER_NOT_FOUND";
    PmVoucherDepositResponseStatus["AMOUNT_IS_INCORRECT"] = "AMOUNT_IS_INCORRECT";
    PmVoucherDepositResponseStatus["CURRENCY_IS_NOT_ALLOWED_FOR_THIS_OPERATOR"] = "CURRENCY_IS_NOT_ALLOWED_FOR_THIS_OPERATOR";
    PmVoucherDepositResponseStatus["REQUEST_ALREADY_IN_PROGRESS"] = "REQUEST_ALREADY_IN_PROGRESS";
    PmVoucherDepositResponseStatus["PAYMENT_GATEWAY_IS_NOT_ACTIVE"] = "PAYMENT_GATEWAY_IS_NOT_ACTIVE";
    PmVoucherDepositResponseStatus["VALIDATION_ERROR"] = "VALIDATION_ERROR";
})(PmVoucherDepositResponseStatus || (exports.PmVoucherDepositResponseStatus = PmVoucherDepositResponseStatus = {}));
